import { findComponentsByIds } from '@api/interfaces/cmsComponentApi';
import useSWRImmutable from 'swr/immutable';
import useStore from '@hooks/useStore';
import useCart from '@hooks/useCart';
import useCustomer from '@hooks/useCustomer';

/**
 * SWR hook for cms components
 *
 * changes to customerId, storeId, slotCode will cause SWR to
 * re-fetch the components
 *
 * @param componentIds
 * @param queryStoreId
 * @param fields
 */
const useCmsComponents = (componentIds?: string, queryStoreId?: string, fields?: 'BASIC' | 'DEFAULT' | 'FULL') => {
  const { store, isLoading: isStoreLoading } = useStore();
  const { cart, isLoading: isCartLoading } = useCart();
  const { customer } = useCustomer();

  const slotCode = cart?.slot?.code;
  const storeId = store?.storeId;

  const shouldFetch = !isStoreLoading && !isCartLoading && Boolean(store) && !!componentIds;

  // useSWRImmutable flags the resource as immutable. Only key changes will trigger re-fetch
  const { data, isLoading, error } = useSWRImmutable(
    shouldFetch
      ? {
          componentIds,
          queryStoreId,
          customerId: customer?.uid,
          storeId,
          slotCode,
        }
      : null,
    ({ componentIds, queryStoreId }) => findComponentsByIds(JSON.parse(componentIds), queryStoreId, fields),
    { keepPreviousData: true }
  );

  return {
    data,
    isLoading,
    error,
  };
};

export default useCmsComponents;
